export const users = {
  title: '账户',
  name: '账户',
  resourceName: '账户',
  titles: {
    view: '查看账户',
    show: '查看账户',
    edit: '编辑账户',
    create: '创建账户',
    list: '账户列表',
    addQuick: '快速添加',
  },
  tabs: {
    profile: '我的资料',
    password: '修改密码',
    settings: '设置',
  },
  fields: {
    firstName: '姓',
    lastName: '名',
    email: '邮箱',
    phoneNumber: '电话号码',
    address: '地址',
    gender: '性别',
    birthday: '生日',
    department: '部门',
    position: '职位',
    dateJoined: '加入日期',
    username: '用户名',
    avatar: '头像',
    avatarZoom: '缩放',
    avatarRotate: '旋转',
    language: '语言',
    theme: '主题',
    timezone: '时区',
    dateFormat: '日期格式',
    'notifications.email': '邮箱通知',
    'notifications.sms': '短信通知',
    'notifications.inApp': '应用内通知',
    id: 'ID',
    role: '角色',
    status: '状态',
    warehouse: '仓库',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
    oldPassword: '旧密码',
    newPassword: '新密码',
    newPasswordRetype: '确认新密码',
  },
  actions: {
    saveProfile: '保存资料',
    saveSettings: '保存设置',
    changePassword: '修改密码',
    changeAvatar: '修改头像',
    cropAvatar: '编辑头像',
    applyCrop: '使用此图片',
    rotate90: '旋转 90°',
    exportList: '导出列表',
    syncFromAuth: '从 Auth 同步',
    columnPicker: '选择显示列',
  },
  messages: {
    noData: '暂无数据',
    loadUserError: '无法加载用户信息',
    totalUsers: '共 {total} 个用户',
    savedSuccess: '保存成功',
    saving: '保存中...',
    updateSuccess: '用户更新成功',
    createSuccess: '用户创建成功',
    errorGeneric: '发生错误',
    loading: '加载中...',
    profileUpdateSuccess: '资料更新成功',
    profileUpdateError: '资料更新失败',
    passwordUpdateSuccess: '密码更新成功',
    passwordUpdateError: '修改密码失败',
    settingsUpdateSuccess: '设置更新成功',
    settingsUpdateError: '设置更新失败',
    avatarUpdateSuccess: '头像更新成功',
    avatarUpdateError: '头像更新失败',
    passwordLength: '密码必须至少8个字符',
    passwordMatch: '密码确认不匹配',
    changePasswordError: '修改密码失败',
    oldPasswordIncorrect: '旧密码不正确',
    userNotFound: '用户不存在或已禁用',
    exportSuccess: '用户列表导出成功',
    exportFailed: '用户列表导出失败',
    syncFromAuthRunning: '正在从 Auth 同步用户…',
    syncFromAuthSuccess:
      '已同步 {tongUser} 名用户（新增 {taoMoi}，更新 {capNhat}），{soPhanQuyen} 条权限。',
    syncFromAuthFailed: '从 Auth 同步用户失败',
  },
  search: {
    title: '用户名',
    placeholder: '用户名',
  },
  filter: {
    placeholder: '按用户名、姓名搜索...',
    advancedFilter: '高级筛选',
    username: '用户名',
    fullName: '姓名',
    role: '角色',
    chucNang: '功能',
    chucNangOptions: {
      nhanVienKinhDoanh: '销售人员',
      nhanVienKyThuat: '技术人员',
    },
    duAn: '项目',
    chiNhanh: '分支',
    clearFilter: '清除筛选',
    search: '搜索',
    all: '全部',
  },
  validation: {
    usernameRequired: '请输入用户名',
    passwordRequired: '请输入密码',
    usernameFormat: '用户名需为 3–50 个字符，仅含字母、数字及 . _ -（不能有空格）',
    passwordLength: '密码至少 8 个字符',
    passwordStrength: '密码必须同时包含字母和数字',
    emailInvalid: '邮箱无效',
    phoneInvalid: '电话号码无效',
  },
  status: {
    active: '启用',
    inactive: '停用',
  },
  roles: {
    super_admin: '超级管理员',
    admin: '管理员',
    manager: '经理',
    standard_user: '员工',
    customer: '客户',
  },
  detailTabs: {
    overview: '概览',
    info: '信息',
    phamViXemDon: '单据可见范围',
    customersInCharge: '负责的客户',
    orders: '订单',
  },
  detail: {
    basicInfo: '基本信息',
    personalInfo: '个人信息',
    unit: '所属单位',
  },
  form: {
    loginInfo: '登录信息',
    personalInfo: '个人信息',
    passwordLabel: '密码',
    usernamePlaceholder: '输入用户名',
    passwordPlaceholder: '输入密码（至少8个字符）',
    fullNamePlaceholder: '输入姓名',
    emailPlaceholder: '输入邮箱',
    phonePlaceholder: '输入电话号码',
    isActiveLabel: '启用',
  },
  phamViXemDon: {
    title: '单据可见范围',
    description: '默认每位员工可查看本项目全部单据。仅在选择「仅本人」或「指定员工」时收窄。',
    loadError: '无法加载单据可见范围。',
    loadOptsError: '无法加载员工/客户列表。',
    savedSuccess: '已保存单据可见范围。',
    saveError: '保存单据可见范围失败。',
    pickUsers: '选择员工…',
    pickCustomers: '选择客户…',
    selectedCount: '已选 {count}',
    saveNguoiBan: '保存',
    saveKhachHang: '保存',
    nguoiBan: {
      title: '按销售员',
      hint: '按销售员设置可查看的订单/发票范围。',
      targets: '可查看单据的员工',
      cheDo: {
        toanDuAn: '查看本项目全部单据',
        toanDuAnShort: '全部',
        toanDuAnHint: '新员工自动纳入，无需重新勾选。',
        chiMinh: '仅本人单据',
        chiMinhShort: '仅本人',
        chiMinhHint: '仅本人销售及本人负责客户。',
        whitelist: '指定可查看单据的员工',
        whitelistShort: '指定员工',
      },
    },
    khachHang: {
      title: '按客户',
      hint: '可打开发票的客户 — 未选则不可见。',
      customers: '可查看的客户',
    },
  },
  profile: {
    title: '个人信息',
    subtitle: '更新您的个人信息',
    personalInfo: '个人信息',
    workInfo: '工作信息',
  },
  changePassword: {
    title: '修改密码',
    subtitle: '更新您的密码以保护您的账户',
    note: '修改成功后系统将退出登录，请使用新密码重新登录。',
  },
  settings: {
    title: '设置',
    subtitle: '更新您的设置',
  },
  departments: {
    HE_THONG: '系统',
    SALES: '销售',
    CUSTOMER_SERVICE: '客户服务',
    DOCUMENTATION: '文档',
    WAREHOUSE: '仓库',
    ACCOUNTING: '会计',
    MANAGEMENT: '管理',
  },
  positions: {
    SYSTEM: '系统',
    HO: 'HO',
    DIRECTOR: '总经理',
    MANAGER: '经理',
    STAFF: '员工',
    INTERN: '实习生',
  },
}
